module.exports = __webpack_public_path__ + "img/nophoto.48165caf.png";